import { Moon } from "lucide-react";
import { Container } from "./container";

export function Footer() {
  return (
    <footer className="border-t border-border bg-surface-2">
      <Container className="flex flex-col items-center justify-between gap-4 py-10 sm:flex-row">
        <div className="flex items-center gap-2 font-display text-lg font-bold">
          <Moon className="h-4 w-4 text-accent" />
          <span>Ronda Malam</span>
        </div>
        <p className="text-sm text-text-muted">
          &copy; {new Date().getFullYear()} Ronda Malam. Keamanan malam berbasis teknologi.
        </p>
        <nav className="flex gap-4 text-sm text-text-muted" aria-label="Tautan kaki">
          <a href="#fitur" className="transition-colors hover:text-text">
            Fitur
          </a>
          <a href="#faq" className="transition-colors hover:text-text">
            FAQ
          </a>
          <a href="#kontak" className="transition-colors hover:text-text">
            Kontak
          </a>
        </nav>
      </Container>
    </footer>
  );
}
